<template>
  <span :class="`badge text-bg${getColor(type)}`">{{label}}</span>
</template>

<script>

export default {
  name: "Badge",
  props: ["type", "label"],
  methods: {
    getColor(type) {
      return `-${type}`
    },
  }
}
</script>

<style scoped>
.text-bg-red{
  color: #fff!important;
  background-color: rgba(239, 32, 32, 0.8)
}
.text-bg-yellow{
  color: #fff!important;
  background-color: rgba(255, 196, 32, 0.8)
}
.text-bg-green{
  color: #fff!important;
  background-color: rgba(25, 135, 84, 0.8)
}
.text-bg-blue{
  color: #fff!important;
  background-color: rgba(32, 91, 239, 0.8)
}
.text-bg-navy{
  color: #fff!important;
  background-color: rgba(32, 35, 239, 0.8)
}
.text-bg-purple{
  color: #fff!important;
  background-color: rgba(108, 32, 239, 0.8)
}
.text-bg-pink{
  color: #fff!important;
  background-color: rgba(199, 139, 217, 0.8)
}
.text-bg-black{
  color: #fff!important;
  background-color: rgb(0, 0, 0)
}
.text-bg-pink{
  color: #fff!important;
  background-color: rgba(199, 139, 217, 0.8)
}
.text-bg-outline{
  color: #000!important;
  border: 1px solid #666;
  background-color: #efefef;
}
.text-bg-default{
  color: #000!important;
  background-color: rgba(206, 203, 203, 0.4)
}
</style>